import React from "react";
import { Document, Page, View } from "@react-pdf/renderer";
import {
  InvoiceHeader,
  BillingSection,
  ItemsTable,
  TotalsSection,
  InvoiceFooter,
} from "./PDFComponents";
import { pdfStyles } from "./PDFStyles";

const InvoicePDF = ({
  invoice,
  facility,
  displayHeaderSettings,
  displayFooterSettings,
}) => {
  // Helper functions
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const formatCurrency = (amount) => {
    return `KES ${amount?.toLocaleString() || "0"}`;
  };

  const getInvoiceType = () => {
    if (invoice?.licenseType) return "Licensed Billing";
    if (invoice?.unitCount !== undefined) return "Fixed Billing";
    if (invoice?.items) return "Facility Invoice";
    return "General Invoice";
  };

  const calculateSubtotal = () => {
    if (invoice?.items) {
      return invoice.items.reduce((sum, item) => sum + (item.amount || 0), 0);
    }
    return invoice?.amount || invoice?.totalAmount || 0;
  };

  const calculateTax = () => {
    const subtotal = calculateSubtotal();
    const taxRate = parseFloat(
      displayFooterSettings?.taxRate || invoice?.taxRate || 0,
    );
    if (taxRate <= 0) return 0;
    return (subtotal * taxRate) / 100;
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const tax = calculateTax();
    return subtotal + tax;
  };

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        {/* Header Section */}
        <InvoiceHeader
          displayHeaderSettings={displayHeaderSettings}
          invoice={invoice}
          formatDate={formatDate}
          getInvoiceType={getInvoiceType}
          calculateSubtotal={calculateSubtotal}
          calculateTax={calculateTax}
          calculateTotal={calculateTotal}
          formatCurrency={formatCurrency}
        />

        {/* Content Section */}
        <View style={pdfStyles.content}>
          {/* Billing Information */}
          <BillingSection
            invoice={invoice}
            facility={facility}
            displayFooterSettings={displayFooterSettings}
            getInvoiceType={getInvoiceType}
          />

          {/* Items Table */}
          <ItemsTable invoice={invoice} formatCurrency={formatCurrency} />

          {/* Totals */}
          <TotalsSection
            calculateSubtotal={calculateSubtotal}
            calculateTax={calculateTax}
            calculateTotal={calculateTotal}
            displayFooterSettings={displayFooterSettings}
            formatCurrency={formatCurrency}
            invoice={invoice}
          />
        </View>

        {/* Footer Section */}
        <InvoiceFooter
          displayHeaderSettings={displayHeaderSettings}
          displayFooterSettings={displayFooterSettings}
        />
      </Page>
    </Document>
  );
};

export default InvoicePDF;
